<div class="pages">
  @for (page of pages | keyvalue: unsorted; track $index) {
    <a
      class="page"
      [ngClass]="{ active: page.key === $path() }"
      [routerLink]="['/legal/', page.key]"
      title="{{
        page.value.title +
          (page.value.description && ' - ' + page.value.description)
      }}"
    >
      <div class="page-label">{{ page.value.title }}</div>
    </a>
  }
</div>

@if ($path() === "identite-entreprise") {
  <div class="block text" id="identite-entreprise">
    <h3>Identité de l'entreprise</h3>
    <p>
      Quentin Petel <br />
      1 La Chaussée<br />
      44520 Moisdon-la-Rivière
    </p>

    <h3>Numéro d'immatriculation au RCS</h3>
    <p>847 761 624 R.C.S. Nantes</p>

    <h3>Mail de contact</h3>
    <p>audio&#64;technomad.fr</p>

    <h3>Numéro d'identification à la TVA</h3>
    <p>FR77847761624</p>

    <h3>Identité de l'hébergeur</h3>
    <p>
      SASU IT-era<br />
      1 La Chaussée<br />
      44520 Moisdon-la-Rivière
    </p>
  </div>
}

@if ($path() === "conditions-generales") {
  <div class="block text" id="conditions-generales">
    <h3>1. Généralités</h3>

    <p>
      Toute commande implique du locataire l'acceptation sans réserve des
      présentes qui régissent exclusivement ses relations avec TECHNOMAD AUDIO
      et prévalent sur tout autre document. TECHNOMAD AUDIO limite son offre de
      location de matériel proposé uniquement au territoire français de la
      métropole.
    </p>

    <h3>2. Conditions requises pour louer</h3>

    <p>
      L'âge minimum pour louer est 18 ans. En garantie de l’exécution du
      contrat, TECHNOMAD AUDIO se réserve la possibilité de soumettre la
      location à la présentation de certains documents (pièce d’identité, permis
      de conduire, justificatif de domicile, etc.) et d'exiger une garantie
      financière, dont la remise s'effectue par tout moyen accepté par TECHNOMAD
      AUDIO, qui pourra l'encaisser à tout moment, sans avis préalable, à charge
      de la restituer après règlement total des sommes dues à TECHNOMAD AUDIO et
      retour du bien loué en bon état. Le montant de la garantie financière ne
      limite pas la responsabilité financière du locataire qui peut être engagé
      au delà en cas de dégradations dépassant ce montant.
    </p>

    <h3>3. Durée de location</h3>

    <p>
      La location prend effet au moment où le matériel est mis à disposition du
      locataire. Cette date est fixée sur le contrat ou le bon de livraison.
      Lors de la remise du matériel, la charge des risques est transférée au
      locataire qui en assume la garde matérielle et juridique sous son entière
      responsabilité. La location et la garde juridique afférente prennent fin
      le jour où la totalité du matériel est restituée par le locataire ou
      repris par TECHNOMAD AUDIO.
    </p>

    <h3>4. Mise à disposition</h3>

    <p>
      1) TECHNOMAD AUDIO ne peut être tenue responsable des éventuels retards de
      mise à disposition ou de livraison, dus à toute raison indépendante de sa
      volonté, notamment intempérie, modification de réglementation, retard dans
      les transports ou les retours des locations précédentes, force majeure,
      grève, ni de leurs conséquences directes ou indirectes à l’égard du
      locataire ou des tiers et n'est redevable d'aucune indemnité à ce titre.
      La "réservation" de matériel ne garantit pas au locataire la date de mise
      à disposition, donnée à titre indicatif et sous réserve de disponibilité
      du matériel.
    </p>

    <p>
      2) Le matériel loué est remis au locataire conforme aux réglementations en
      vigueur, notamment concernant la sécurité et l'hygiène des travailleurs.
      Le locataire reconnaît avoir reçu le matériel en bon état d’usage et
      d’entretien, apte au fonctionnement, avec la notice technique, les
      consignes de sécurité et les accessoires nécessaires. Le cas échéant, les
      équipements de protection individuels sont remis avec le matériel. Il
      appartient au locataire de choisir le matériel en fonction de ses besoins
      qu’il a lui-même préalablement déterminés et de vérifier qu'il soit
      adéquat. TECHNOMAD AUDIO n’a pas connaissance des projets du locataire ni
      l'obligation de vérifier le choix du locataire sur la faisabilité et la
      compatibilité du matériel à son projet de sorte que sa responsabilité ne
      saurait être engagée à cet égard.
    </p>

    <p>
      3) Le transport, chargement, déchargement et arrimage du matériel sont à
      la charge et sous la responsabilité du locataire, sauf en cas de livraison
      par TECHNOMAD AUDIO. A la prise de possession du matériel, le contrat de
      location et le cas échéant le bon de livraison sont signés. A défaut de
      réserve, le matériel est réputé avoir été remis au locataire en bon état
      d'usage et d'entretien. En cas de livraison, le locataire s'engage à
      remettre au chauffeur TECHNOMAD AUDIO, le cas échéant, les instructions
      particulières à respecter sur le site de livraison et déchargement.
      L'installation, le montage et le démontage sont effectués sous la
      responsabilité du locataire qui s'engage à prendre connaissance des règles
      de montage, de fonctionnement et de sécurité prescrites par la
      réglementation et le constructeur du matériel. L’obligation de TECHNOMAD
      AUDIO se limite à la remise des notices d’utilisation.
    </p>

    <h3>5. Utilisation</h3>

    <p>
      1) Le locataire certifie être habilité à se servir du matériel qu'il
      s'engage à utiliser lui-même ou par l'intermédiaire de son personnel
      dûment qualifié, formé et habilité. Le prêt et la sous-location du
      matériel sont strictement interdits.
    </p>

    <p>
      2) Il s'engage à installer et utiliser le matériel conformément à sa
      destination et aux réglementations en vigueur, avec prudence et diligence,
      à respecter les consignes et notices d’utilisation et de sécurité, et à le
      maintenir constamment en bon état de marche. Il prend toute mesure utile
      pour que les règles de sécurité légales, réglementaires ou édictées par le
      constructeur soient appliquées. Il est responsable de la vérification de
      la nature du sol ou du sous-sol du site d'utilisation du matériel, et du
      respect des règles régissant le domaine public et la prise en compte de
      l'environnement. Il s’interdit toute modification, aménagement ou
      transformation du matériel. Sauf accord écrit de TECHNOMAD AUDIO, il n'est
      autorisé à utiliser le matériel qu'en France.
    </p>

    <h3>6. Entretien</h3>

    <p>
      Le locataire est tenu de protéger le matériel contre toute dégradation et
      de le faire fonctionner conformément aux normes du fabricant. Tout frais
      de réparation consécutif à une dégradation ou défaut de fonctionnement ou
      de manipulation du matériel lui incombant reste à sa charge.
    </p>

    <h3>7. Réparations</h3>

    <p>
      TECHNOMAD AUDIO ne peut être tenu responsable à l’égard du locataire ou
      des tiers des conséquences directes ou indirectes, matérielles ou
      immatérielles, d'un arrêt de fonctionnement du bien loué, qui ne serait
      pas dû à un vice existant au moment de la mise à disposition. La
      responsabilité de TECHNOMAD AUDIO demeure en toutes hypothèses limitée au
      montant de la location du matériel en cause. En cas de panne ou
      dysfonctionnement, le locataire doit immédiatement cesser d'utiliser le
      matériel, aviser TECHNOMAD AUDIO par téléphone et lui adresser
      confirmation par écrit relatant les circonstances sous 48h. Toute
      réparation n'est effectuée qu’à l’initiative de TECHNOMAD AUDIO, sa charge
      financière étant répartie selon les dispositions du paragraphe 8. Une
      indemnité d'immobilisation du matériel pendant le temps des réparations
      pourra être facturé dès lors que cette immobilisation n’est pas imputable
      à TECHNOMAD AUDIO.
    </p>

    <h3>8. Responsabilités Caution et Assurance</h3>

    <p>
      - Caution : Une caution vous sera demandée lors du retrait du matériel.
      Son montant est calculé sur une base de 5x le montant de la location. La
      caution sera a versé en espèce ou cheque. Attention le titulaire du chèque
      devra être présent lors du retrait du matériel muni d’une (<1000€) ou 2
      pièces d’identités (>1000€). En cas de location de matériel sensible une
      caution complémentaire pourra vous être demandée.
    </p>

    <p>
      - Assurances : Le locataire ne peut employer le matériel à un autre usage
      que celui auquel il est destiné ni enfreindre les règles de sécurité. Il
      assume la garde matérielle et juridique du matériel et est responsable des
      dommages causés par et au matériel loué. Toutefois, il ne saurait être
      tenu des conséquences dommageables des vices cachés du matériel le rendant
      impropre à sa destination, dès lors qu'il apporte la preuve des dits
      vices. TECHNOMAD AUDIO ne peut être tenu responsable des pertes, vols ou
      dommages causés à tous biens transportés ou laissés par le locataire ou
      tout tiers, dans ou sur le matériel pendant la durée de la location ou
      après restitution du matériel.
    </p>
    <br />
    1) dommages aux tiers (responsabilité civile).
    <p>
      Pour la location, le locataire doit être titulaire d'une assurance
      responsabilité civile entreprise ou chef de famille pour couvrir les
      dommages causés aux tiers par le matériel.
    </p>
    <br />
    2) dommages au bien loué
    <p>
      Le locataire est responsable de l’utilisation du matériel et des dommages
      subis par ce matériel. Il assume la charge des conséquences financières de
      ces dommages. En cas de perte totale, vols ou détérioration rendant le
      matériel hors d'usage, TECHNOMAD AUDIO facturera le dit matériel à sa
      valeur de remplacement. Il peut couvrir cette responsabilité en
      contractant lui-même une assurance.
    </p>

    <h3>9. Déclaration en cas de sinistre</h3>

    <p>
      En cas d'incident de quelque nature que ce soit, le locataire s'engage à
      informer TECHNOMAD AUDIO dès la connaissance de l'incident et à lui
      transmettre sa déclaration de sinistre par écrit au plus tard dans les
      72h. Il doit mentionner date, lieu, circonstances, causes et conséquences
      présumées, nom et adresse de l'auteur présumé, des victimes, des témoins,
      si des agents de l'autorité sont intervenus et si un procès-verbal a été
      établi, l'endroit où les dommages peuvent être constatés, les garanties
      souscrites auprès d'assureurs. Il doit permettre à TECHNOMAD AUDIO l'accès
      au matériel. En cas d'implication de véhicules terrestres à moteur
      (sinistre matériel et/ou corporel), il doit rédiger et transmettre à
      TECHNOMAD AUDIO le constat amiable dûment signé par les conducteurs. En
      cas de vol, il doit faire dans les 48h auprès des autorités une
      déclaration mentionnant l'identification du matériel, la date et les
      circonstances du vol et transmettre les originaux à TECHNOMAD AUDIO dans
      le même délai ou sur demande. La location est facturée jusqu'au jour de
      réception de la déclaration écrite du locataire.
    </p>

    <h3>10. Infractions</h3>

    <p>
      Le locataire reste seul responsable des infractions commises par lui ou
      ses préposés et en supporte les conséquences pénales, civiles et fiscales.
      En cas de paiement par TECHNOMAD AUDIO de frais de toute nature liés à ces
      infractions, il s'engage à les rembourser à TECHNOMAD AUDIO sur demande
      justifiée. TECHNOMAD AUDIO pourra transmettre aux autorités les
      informations nominatives le concernant.
    </p>

    <h3>11. Prix de location</h3>

    <p>
      Indépendamment de la durée de location, le prix de location est fixé par
      unité de temps à rappeler dans la commande pour chaque location (jour,
      semaine, mois). A défaut de précision, l'unité de temps retenue est le
      jour calendaire, soit 24h non fractionnables depuis l'heure de mise à
      disposition du matériel. Les tarifs indiqués sur le site le sont pour une
      location d'une durée allant jusqu'à 48h. Chaque tranche de 24h
      supplémentaire débutée est facturée 25% du prix indiqué. Toute unité de
      temps commencée est due par le locataire. L'intégralité de la durée de
      mise à disposition du matériel est facturée au locataire, sans qu'il ne
      puisse opposer d'évènements venant la réduire.
    </p>

    <h3>12. Annulation</h3>

    <p>
      Toute réservation de matériel est effectuée de façon ferme et définitive.
      Néanmoins, à titre commercial pour une annulation a plus de 15 jours de la
      date de la location, un avoir pourra vous être effectué déduction faite de
      15€ de frais de gestion. A moins de 15j, 50% du montant sera dûe. A moins
      de 7j, paiement total de la location vous sera réclamée.
    </p>

    <h3>13. Restitution</h3>

    <p>
      1) Le matériel ne peut être restitué que pendant les heures d'ouverture.
      En cas de reprise par TECHNOMAD AUDIO, le locataire doit informer
      TECHNOMAD AUDIO par écrit de la disponibilité du matériel avec un préavis
      raisonnable et suffisant en précisant le lieu où il se trouve. Le matériel
      à reprendre doit être tenu dans un endroit accessible pour TECHNOMAD
      AUDIO. Le locataire reste tenu de toutes les obligations découlant du
      contrat jusqu'à récupération effective par TECHNOMAD AUDIO, il reste
      notamment gardien de la chose louée et s'engage à la conserver sous
      surveillance. Le matériel ne sera considéré "restitué", et la garde
      juridique transférée, à TECHNOMAD AUDIO qu'après remise à un salarié de
      TECHNOMAD AUDIO. La restitution est obligatoire à l'expiration du contrat
      sans qu'il y ait lieu d'adresser une mise en demeure.
    </p>
    <p>
      2) Le locataire est tenu de rendre le matériel en bon état et en
      conformité, avec tous les accessoires et équipements, notamment
      dispositifs de sécurité, nettoyé. A défaut, les prestations de remise en
      état, nettoyage sont facturées. En cas de vol ou perte, le contrat et la
      facturation de location ne prennent fin qu’à réception par TECHNOMAD AUDIO
      de la déclaration du locataire auprès des autorités compétentes. En cas de
      non restitution du matériel quel qu'en soit la cause, une indemnité est
      facturée sur la base de la valeur de remplacement, en sus de la location.
      Les équipements, accessoires, éléments démontables ou pièces détachées non
      restitués sont facturés au prix de remplacement.
    </p>

    <h3>14. Éviction du louer</h3>

    <p>
      Le locataire s'interdit d'enlever ou modifier les plaques de propriété
      et/ou inscriptions apposées sur le bien loué. Le matériel ne peut être ni
      cédé, ni remis en garantie. Le locataire s'engage à ne consentir à l'égard
      de la chose louée aucun droit, réel ou autre, au profit de quiconque,
      susceptible d'en affecter la jouissance, ou d'en limiter la disponibilité
      ou la pleine propriété de TECHNOMAD AUDIO.
    </p>

    <h3>15. Règlements</h3>

    <p>
      Toute facture est payable au comptant, 50% à la réservation, le solde au
      retrait du matériel. Le règlement peut être fait en espèce, par carte
      bancaire ou mandat administratif. Toute somme non payée à échéance
      entraîne le paiement de pénalités de retard au taux égal à 1,5 fois le
      taux d'intérêt légal en cours ainsi que la déchéance de tous délais de
      paiement. En cas d'intervention contentieuse de TECHNOMAD AUDIO pour le
      recouvrement des sommes dues, et après mise en demeure restée sans effet
      pendant 8 jours, le locataire sera redevable à titre de dommages et
      intérêts d'une pénalité forfaitaire égale à 15 % de la somme impayée TTC.
    </p>

    <h3>16. Clause résolutoire</h3>

    <p>
      En cas d'inexécution par le locataire d'une obligation à sa charge,
      notamment non restitution du matériel ou défaut de paiement du loyer, le
      contrat peut être résilié de plein droit par TECHNOMAD AUDIO aux torts du
      locataire 48h après mise en demeure par lettre recommandée avec AR restée
      infructueuse. Dans ce cas, TECHNOMAD AUDIO exige la restitution immédiate
      du matériel sans préjudice des sommes dues au titre des périodes de
      location échues, sous peine des sanctions prévues au paragraphe 13 ou
      d'application d'une indemnité journalière d'immobilisation égale au loyer
      journalier, et de plainte au titre de l’article 314-1 du code pénal. Le
      locataire reste en tout état de cause responsable du matériel et en
      devient dépositaire au sens de l'Art 1915 C Civ. Il n'a ni le droit de
      s'en servir, ni d'en disposer à quelque titre que ce soit. En cas de
      résiliation anticipée d'un contrat comportant un prix forfaitaire fixé en
      fonction d'une durée incompressible de location, TECHNOMAD AUDIO percevra
      une indemnité égale à la totalité du loyer restant à courir ou révisera le
      prix initialement indiqué en fonction de la durée effective de location.
    </p>

    <h3>17. Nuisances sonores</h3>

    <p>
      Le locataire reconnaît expressément avoir pris connaissance des
      caractéristiques acoustiques du matériel et s'engage à prendre toutes
      dispositions permettant d'éviter toutes nuisances.
    </p>

    <h3>18. Loi applicable et attribution de juridiction</h3>

    <p>
      Le présent contrat est régi par la loi française et soumis à la
      juridiction exclusive des tribunaux français. Tout différend relatif aux
      présentes conditions sera tranché par le Tribunal de Commerce du siège
      social de TECHNOMAD AUDIO auquel les parties attribuent une compétence
      exclusive, même en cas d’appel en garantie ou de pluralité de défendeurs.
      Tout différend relatif aux présentes conditions impliquant un consommateur
      sera soumis aux règles légales de compétence d'attribution et
      territoriale.
    </p>
  </div>
}
